import SvgIcon from "@mui/material/SvgIcon";
import { disabledFlagStyle } from "./index";

export default function DeFlag({ active }: { active?: boolean }) {
  return (
    <SvgIcon
      aria-hidden
      role="presentation"
      style={!active ? disabledFlagStyle : {}}
      titleAccess="flag-de"
      viewBox="0 0 640 480"
    >
      <g fillRule="evenodd" strokeWidth="1pt">
        <path d="M0 320h640v160.002H0z" fill="#ffe600" />
        <path d="M0 0h640v160H0z" fill="black" />
        <path d="M0 160h640v160H0z" fill="red" />
      </g>
    </SvgIcon>
  );
}
